<div class="w-100 overflow-hidden">
  <div *ngIf="!(loading$|async);else loading" class="top-outer-container"
       [class.offer-selected]="selectedOffer != null && !deselectOffer.value">
    <div *ngIf="offers$|async as offers; else loading" class="outer-container h-100 mb-2 w-100 offer-list">

      <ng-container *ngIf="(selectedOffer!=null)"></ng-container>

      <div class="d-flex flex-row"
        [class]="user.id === proposalTile.userId && proposalTile.status != ProposalStatus.RETRACTED && proposalTile.coverage < 1 ? 'justify-content-between' : 'justify-content-end'">
        <button
          class="align-self-start mb-4 save-button blue-content external-coverage-button"
          *ngIf=" user.id === proposalTile.userId && proposalTile.status != ProposalStatus.RETRACTED && proposalTile.coverage < 1"
          (click)="navigateToCreateExternalCoverage()">
          <span>
            {{'createOffer.external.addExternalCoverage' | translate}}
          </span>
          <mat-icon>arrow_forward</mat-icon>
        </button>

        <button class="blue-border note-button mb-1"
            [class]="user.id === proposalTile.userId && proposalTile.status != ProposalStatus.RETRACTED ? 'me-3' : ''"
            *ngIf="offers.length > 0"
            (click)="openPrivateNoteDialog(PrivateNoteLocation.OFFER_OVERVIEW)"
            [class]="(privateNoteOverview$|async)?.note ? 'active' : ''"
            matTooltip="{{'proposalDetails.privateNote' | translate}}"
            [matTooltipShowDelay]="1000">
          <img class="icon" alt="" [src]="(privateNoteOverview$|async)?.note ? 'assets/svg-icons/comment-active.svg' : 'assets/svg-icons/comment.svg'">
        </button>
      </div>

      <app-offer-overview *ngIf="offers.length > 0" [offers]="offers"
                          [proposalId]="proposalTile.id"
                          [selectedOffer]="null"
                          (selectedOfferChange)="selectedOffer = $event"
                          (selectedPrivateNote)="privateNote = $event"
                          [insuredAmount]="proposalTile.insuredAmount"></app-offer-overview>

      <div *ngIf="offers.length == 0">
        <div class="no-offer">
          <img class="icon" alt="{{'offer.noOffers' | translate }}" src="assets/svg-icons/blur-on.svg">
          <br />
          <h5 class="mt-5 text-nowrap text-center" *ngIf="(roles$|async).includes(Roles.ROLE_BROKER)"> {{'offer.noOffers.Broker.1' | translate }} </h5>
          <h6 class="mt-3 text-center" *ngIf="(roles$|async).includes(Roles.ROLE_BROKER)"> {{'offer.noOffers.Broker.2' | translate }} <br /> {{'offer.noOffers.Broker.3' | translate }}</h6>

          <h5 class="mt-5 text-nowrap text-center" *ngIf="((roles$|async).includes(Roles.ROLE_INSURER) || (roles$|async).includes(Roles.ROLE_UNDERWRITER))"> {{'offer.noOffers.Insurer.1' | translate }} </h5>
          <h6 class="mt-3 text-center" *ngIf="((roles$|async).includes(Roles.ROLE_INSURER) || (roles$|async).includes(Roles.ROLE_UNDERWRITER))"> {{'offer.noOffers.Insurer.2' | translate }}</h6>

        </div>
      </div>

    </div>
    <div
      class="details-tab w-100">
      <ng-container *ngIf="selectedOffer != null">
        <app-offers-details-tab [offer]="selectedOffer" [proposalTile]="proposalTile"
                                [offers]="offers$ | async"
                                class="d-flex flex-column flex-grow-1 w-100 "
                                (offerChange)="deselectOffer.next(true)"
                                (navigateToOffer)="onNavigateToOffer($event)">
          <div class="d-flex flex-row">
            <button class="blue-border note-button me-3"
                (click)="openPrivateNoteDialog(PrivateNoteLocation.OFFER_DETAIL)"
                [class]="privateNote?.note ? 'active' : ''"
                matTooltip="{{'proposalDetails.privateNote' | translate}}"
                [matTooltipShowDelay]="1000">
              <img class="icon" alt="" [src]="privateNote?.note ? 'assets/svg-icons/comment-active.svg' : 'assets/svg-icons/comment.svg'">
            </button>
            <button class="blue-border note-button me-3"
                (click)="openOfferVersionHistoryDialog(selectedOffer)"
                matTooltip="{{'offer.versionHistory.dialogTitle' | translate}}"
                [matTooltipShowDelay]="1000">
              <mat-icon class="icon">history</mat-icon>
            </button>

            <div
              *ngIf="((user$|async).id == selectedOffer.creator.id) && showRefillOfferButton()">
            <button class="blue-border refill-button gap-0 me-2 mb-1"
                    (click)="openRefillOfferModal(selectedOffer)">
              <img alt="" src="assets/svg-icons/refill-circle.svg" class="me-2">
              {{ 'offer.refillOffer' | translate }}
            </button>
            </div>

            <div
              *ngIf="((user$|async).id == selectedOffer.creator.id) && showEditOfferButton()">
              <button class="blue-border edit-button gap-0 me-2 mb-1"
                      (click)="handleRefillOffer(selectedOffer)">
                <img alt="" src="assets/svg-icons/refill-circle.svg" class="me-2">
                {{ 'offer.editOffer' | translate }}
              </button>
            </div>

            <div
              *ngIf="((user$|async).id == selectedOffer.creator.id) && showRetractOfferButton()"
              class="flex-column d-flex align-items-end">
              <button class="retract-button me-3 mb-1"
                    (click)="openRetractionModal()">
                <img alt="" src="assets/svg-icons/retract-arrow.svg" class="me-2">
                {{'offer.retractOffer' |translate}}
              </button>
            </div>
            <div class="d-flex flex-column align-items-end">
              <button *ngIf="((user$|async).id == proposalTile.userId || ((this.user$|async).isBusinessAdmin === true && (this.user$|async)?.company?.name === proposalTile.companyName) || (this.user$|async).representedUsers.includes(proposalTile.userId))  && showAcceptOfferButton()" class="menu-button save-button me-3 mb-1"
                      [disabled]="((hasLead$|async) && selectedOffer.isLeading) || !coverageBelowAllowedAmount()"
                      (click)="openModal()">{{'offer.acceptOffer' |translate}}
              </button>
            </div>
          </div>
        </app-offers-details-tab>

      </ng-container>
    </div>
  </div>
</div>
<ng-template #loading>
  <mat-spinner class="mt-4 loading-spinner"></mat-spinner>
</ng-template>

<app-offer-status-change-modal [proposalTile]="proposalTile" [selectedOffer]="selectedOffer"
                               (deselectOffer)="deselectOffer.next(true)"
                               [(showAcceptOffer)]="showAcceptOffer"
                               [(showRetractOffer)]="showRetractOffer"></app-offer-status-change-modal>
